import { filterPricesByFlag, isFlagEnabled } from '@/utils/precios/filterPricesByFlag';

const AMIGO_ABONADO_FLAG = 'amigo_abonado';

function preciosAmigoAbonadoDeZona(zona) {
    if (!zona) {
        return [];
    }

    const preciosAmigo = zona.precios_amigo_abonado;
    if (Array.isArray(preciosAmigo) && preciosAmigo.length > 0) {
        return preciosAmigo;
    }

    const precios = Array.isArray(zona.precios) ? zona.precios : [];
    const preciosMarcados = filterPricesByFlag(precios, AMIGO_ABONADO_FLAG);
    return preciosMarcados.length > 0 ? preciosMarcados :
        (isFlagEnabled(zona.amigo_abonado) ? precios : []);
}

function formatearZonaAmigoAbonado(zona) {
    const precios = preciosAmigoAbonadoDeZona(zona);
    return {
        ...zona,
        precios_amigo_abonado: precios,
        esta_disponible: Boolean(zona.esta_disponible && precios.length > 0)
    };
}

function esZonaConButacas(zona) {
    if (!zona) {
        return false;
    }

    if (zona.tiene_plazas === 0) {
        return true;
    }

    const faltaTipoPlazas = zona.tiene_plazas === undefined || zona.tiene_plazas === null;
    return faltaTipoPlazas && zona.tiene_recinto && zona.with_seats === true;
}

function maximoEntradasAmigoAbonado(evento) {
    const maximo = Number(evento && evento.n_acompanantes);
    return Number.isFinite(maximo) && maximo > 0 ? maximo : 1;
}

function preciosAmigoAbonadoDePlaza({ plaza, tarifasDeTaquilla, preciosAmigoAbonado, zona }) {
    const preciosMarcados = filterPricesByFlag(tarifasDeTaquilla || plaza?.precios, AMIGO_ABONADO_FLAG);
    if (preciosMarcados.length > 0) {
        return preciosMarcados;
    }

    if (Array.isArray(preciosAmigoAbonado) && preciosAmigoAbonado.length > 0) {
        return preciosAmigoAbonado;
    }

    const preciosZonaAmigo = preciosAmigoAbonadoDeZona(zona);
    if (preciosZonaAmigo.length > 0) {
        return preciosZonaAmigo;
    }

    if (!isFlagEnabled(zona && zona.amigo_abonado)) {
        return [];
    }

    const preciosPlaza = plaza && Array.isArray(plaza.precios) ? plaza.precios : [];
    return preciosPlaza;
}

export function useAmigoAbonadoTaquilla() {
    return {
        esZonaConButacas,
        formatearZonaAmigoAbonado,
        maximoEntradasAmigoAbonado,
        preciosAmigoAbonadoDePlaza,
        preciosAmigoAbonadoDeZona
    };
}
